<div class="no-access-container">
  <div class="no-access-card">
    <div class="no-access-icon">
      <img src="/images/access_denied.png" alt="Access Denied" />
    </div>
    <h2 class="no-access-title">Access Denied</h2>
    <p class="no-access-message">You don't have permission to access the Admin Tab.</p>
    <p class="no-access-message">Please contact your administrator for access.</p>
  </div>
</div>
